import { RichiestaModuloDTOPermessiItem } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTOPermessiItem.ts';
import { useCurrentUser } from '@framework/auth/state/AuthSlice.tsx';
import { getSubmissionDelegationRole } from '@framework/frontoffice-submission/module/delegation/DelegationMachine.ts';
import {
  type IModuleStateMachineRecord,
  ModuleStateMachine,
} from '@framework/frontoffice-submission/module/fsm/ModuleStateMachine.ts';
import { SubmissionLogic } from '@framework/frontoffice-submission/submission/SubmissionLogic.ts';
import { SummaryDetailCard } from '@framework/ui/components/summary/SummaryDetailCard.tsx';
import { lighten } from 'polished';
import styled from 'styled-components';
import { BackToCompilationButton } from './action-buttons/BackToCompilationButton.tsx';
import { FinishCompilingButton } from './action-buttons/FinishCompilingButton.tsx';
import { ReadyToSignButton } from './action-buttons/ReadyToSignButton.tsx';
import { SignActionButtons } from './action-buttons/SignActionButtons.tsx';
import { SignToCompilationButton } from './action-buttons/SignToCompilationButton.tsx';

const ActionButtonsContainer = styled.div`
  > * + * {
    border-top: 1px solid
      ${props => lighten(0.2, props.theme.moduleDelegateColor)};
    margin-top: 24px;
    padding-top: 24px;
  }
`;
export interface IModuleStateBottomBoxProps {
  data: IModuleStateMachineRecord;
}

export function ModuleStateBottomBox(props: IModuleStateBottomBoxProps) {
  const { data } = props;
  const user = useCurrentUser();

  // Controllo se la compilazione del modulo può essere completata automaticamente
  // o richiede l'intervento manuale dell'utente.
  const isAutoComplete = ModuleStateMachine.can(data, '.autoComplete', user);

  // Se è possibile completare automaticamente il modulo, non mostro nessun pulsante
  if (isAutoComplete.allowed) {
    return null;
  }

  if (SubmissionLogic.isSubmissionSent(data.submission)) {
    return null;
  }

  if (
    data.module?.permessi?.every(
      p => p === RichiestaModuloDTOPermessiItem.VISUALIZZAZIONE,
    ) &&
    getSubmissionDelegationRole(data.delegationData, user) === 'delegate'
  ) {
    return null;
  }

  return (
    <SummaryDetailCard variant="signer" style={{ marginBottom: 8 }}>
      <ActionButtonsContainer>
        <ReadyToSignButton {...props} />
        <FinishCompilingButton {...props} />
        <SignActionButtons {...props} />
        <BackToCompilationButton {...props} />
        <SignToCompilationButton {...props} />
      </ActionButtonsContainer>
    </SummaryDetailCard>
  );
}
